export enum EmptyDistanceStrategy {
  NONE = 'none',
  PERCENTAGE_OR_VALUE = 'percentage-or-value',
  PERCENTAGE_AND_VALUE = 'percentage-and-value',
  PERCENTAGE = 'percentage',
  VALUE = 'value',
}
